module.exports = __webpack_public_path__ + "img/14.c454d571.jpg";